<template>
  <v-tooltip
    right
    open-delay="270"
    :disabled="disableTooltip"
  >
    <template #activator="{ on, attrs }">
      <v-avatar
        class="noselect"
        :color="color"
        size="32"
        v-bind="attrs"
        v-on="on"
      >
        <span
          class="text-subtitle-1"
          :style="`color: ${textColor}`"
        >{{ accountInitials }}</span>
      </v-avatar>
    </template>
    <span>{{ accountName }}</span>
  </v-tooltip>
</template>

<script lang='ts'>

import Vue, { PropType } from 'vue';
import runes from 'runes';
import { contrastForColor } from '@/services/color-utils';

export default Vue.extend({
  name: 'AccountAvatar',
  props: {
    accountName: { type: String, required: true },
    color: { type: String, required: true },
    disableTooltip: { type: Boolean, required: false, default: false },
  },
  data() {
    return { };
  },
  computed: {
    accountInitials(): string {
      if (this.accountName === undefined || this.accountName.length === 0) {
        return 'GP';
      }
      const accName = this.accountName.split(' ');
      if (accName.length === 1) {
        return runes.substr(this.accountName, 0, 2);
      }
      return `${runes.substr(accName[0], 0, 1)}${runes.substr(accName[accName.length - 1], 0, 1)}`;
    },
    textColor(): string {
      if (this.color === 'brand') { return '#ffffff'; }
      return contrastForColor(this.color);
    },
  },
  methods: {},
});

</script>
